import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: ${({ columns }) => columns ?? "1fr"};
  grid-column-gap: ${({ columnGap }) => columnGap ?? "0rem"};
  grid-row-gap: ${({ rowGap }) => rowGap ?? "0rem"};
`;
